import { useEffect, useState } from 'react';

const REFRESH_ERROR = 'Your intake is saved, but we couldn’t refresh the email status. Please call 949-883-6001 if you need assistance.';

async function fetchReceipt(id, signal) {
  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/intakes/${id}/status`, { cache: 'no-store', signal });
  if (!response.ok) throw new Error('Receipt status unavailable');
  const receipt = await response.json();
  if (receipt.id !== id) throw new Error('Receipt reference mismatch');
  return receipt;
}

export function useIntakeReceiptStatus(id, status, onReceipt) {
  const [refreshError, setRefreshError] = useState('');
  useEffect(() => {
    setRefreshError('');
    if (status !== 'pending') return;
    let disposed = false;
    let attempts = 0;
    let controller;
    let timer;
    let requestTimeout;
    const poll = async () => {
      attempts++;
      controller = new AbortController();
      requestTimeout = setTimeout(() => controller.abort(), 15000);
      let nextStatus = 'pending';
      try {
        const next = await fetchReceipt(id, controller.signal);
        if (disposed) return;
        nextStatus = next.notificationStatus;
        setRefreshError(''); onReceipt(next);
      } catch {
        // Cleanup cancellations are expected; report other failures without exposing answers.
        if (!disposed) setRefreshError(REFRESH_ERROR);
      } finally {
        clearTimeout(requestTimeout);
      }
      if (!disposed && nextStatus === 'pending' && attempts < 20) timer = setTimeout(poll, 3000);
    };
    timer = setTimeout(poll, 3000);
    return () => { disposed = true; clearTimeout(timer); clearTimeout(requestTimeout); controller?.abort(); };
  }, [id, status, onReceipt]);
  return refreshError;
}